import React from 'react';
import { Modal, ModalBody } from 'reactstrap';
import styled from 'styled-components';
import HOURGLASS_TOP from '../../assets/img/hourglass-top.svg';

const ModalBodyContainer = styled(ModalBody)`
  font-weight: 500;
  font-size: 18px;
  padding: 50px;
  display: flex;
  justify-content: center;
  border-radius: 8px;
`;

const AudioVideoUploadingModal = ({ show, modalConfig }) => {
  let pendingItem = '';
  if (modalConfig.audioUploadInProgress) pendingItem = 'Audio/';
  if (modalConfig.videoUploadInProgress) pendingItem += 'Video/';

  pendingItem = pendingItem.slice(0, -1);

  return (
    <Modal isOpen={show} centered backdrop="static" size="lg">
      <ModalBodyContainer>
        <img className="fa-spin mr-2" src={HOURGLASS_TOP} alt="hourglass" />
        {`${pendingItem} upload in progress. Please don't close/refresh this window
        till upload completes.`}
      </ModalBodyContainer>
    </Modal>
  );
};

export default AudioVideoUploadingModal;
